export class Permissions {
    public static PreRelease = "portal.prerelease";
    
    public static CreateSubmission = "submission.create";
    public static EditSubmission = "submission.edit";
    public static UploadSubmission = "submission.upload";
    public static LegacyLabConnect = "submission.legacy";
    public static SampleTimer = "submission.timer";
    public static CloudSubmissions = "submission.cloud";
    public static ManualImageUpload = "submission.manualupload";
    
    public static ViewResults = "results.view";
    
    public static ControlPanel = "controlpanel.access"
    public static ControlPanelPreparation = "controlpanel.preparation";
    public static ControlPanelCameraProfiles = "controlpanel.cameraprofiles";
    public static ControlPanelCameraRange = "controlpanel.camerarange";
    public static ControlPanelMoveCassette = "controlpanel.movecassette";
    public static ControlPanelImagePosition = "controlpanel.imageposition";
    public static ControlPanelZoom = "controlpanel.zoom";
    public static ControlPanelFocus = "controlpanel.focus";
    public static ControlPanelImageCapture = "controlpanel.imagecapture";
    public static ControlPanelVideoCapture = "controlpanel.videocapture";
    public static ControlPanelCamera = "controlpanel.camera";
    public static ControlPanelBrightness = "controlpanel.brightness";
    public static ControlPanelWhiteBalance = "controlpanel.whitebalance";
    public static ControlPanelLighting = "controlpanel.lighting";
    public static ControlPanelViewSettings = "controlpanel.viewsettings";
    public static ControlPanelBacklash = "controlpanel.backlash";
    
    public static SharedData = "shareddata.view";
    
    public static TestKitOfferings = "testkits.offerings.view";
    public static TestKitLocales = "testkits.locales.view";
    public static TestKitsRead = "testkits.management.read";
    public static TestKitsWrite = "testkits.management.write";
    public static TestKitCSVAssign = "testkits.management.csvassign";
    
    public static MarketingCarousel = "marketingandpromotions.carousel.view";
    public static MarketingDashboard = "marketingandpromotions.notices.view";
    
    public static Software = "software.view";
    
    public static RataPlatform = "rataplatform.view";
    
    public static UserGuidesView = "userguides.view";
    public static UserGuidesManage = "userguides.manage";
    
    public static Hardware = "hardware.view";
    
    public static RolesAndPermissions = "rolesandpermissions.view";
    
    public static Distributors = "supplychain.distributors.view";
    public static AddDistributor = "supplychain.distributors.add";
    public static EditDistributor = "supplychain.distributors.edit";
    public static DistributorAddresses = "supplychain.distributors.addresses";
    public static DistributorBranding = "supplychain.distributors.branding";
    public static DistributorContacts = "supplychain.distributors.contacts";
    public static DistributorPostTreatmentCalculator = "supplychain.distributors.posttreatmentcalculator";
    
    public static Groups = "supplychain.groups.view";
    public static AddGroup = "supplychain.groups.add";
    public static EditGroup = "supplychain.groups.edit";
    public static GroupAddresses = "supplychain.groups.addresses";
    public static GroupBranding = "supplychain.groups.branding";
    public static GroupContacts = "supplychain.groups.contacts";
    public static GroupSpecies = "supplychain.groups.species";
    public static GroupProducts = "supplychain.groups.products"
    public static GroupDisclaimer = "supplychain.groups.disclaimer";
   public static GroupEvents = "supplychain.groups.events";
   public static GroupActivityEvents = "supplychain.groups.activityevents";
   public static GroupBusinessActivities = "supplychain.groups.businessactivities";
    public static GroupPostTreatmentCalculator = "supplychain.groups.posttreatmentcalculator";
    
    public static Sites = "supplychain.sites.view";
    public static AddSite = "supplychain.sites.add";
    public static EditSite = "supplychain.sites.edit";
    public static SiteAddresses = "supplychain.sites.addresses";
    public static SiteBranding = "supplychain.sites.branding";
    public static SiteContacts = "supplychain.sites.contacts";
    public static SiteSubscriptions = "supplychain.sites.subscriptions";
    public static SiteDisclaimer = "supplychain.sites.disclaimer";
    public static SiteWaitTimes = "supplychain.sites.waittimes";
    public static SiteEvents = "supplychain.sites.events";
    
    public static Accounts = "supplychain.accounts.view";
    public static AddAccount = "supplychain.accounts.add";
    public static EditAccount = "supplychain.accounts.edit";
    public static AccountBranding = "supplychain.accounts.branding";
    public static AccountSubscriptions = "supplychain.accounts.subscriptions";
    public static AccountWaitTimes = "supplychain.accounts.waittimes";
    
    public static AccountProperties = "supplychain.properties.view";
    public static AddProperty = "supplychain.properties.add";
    public static EditProperty = "supplychain.properties.edit";
    public static PropertyAddresses = "supplychain.properties.addresses";
    public static PropertyContacts = "supplychain.properties.contacts";
    public static PropertyEvents = "supplychain.properties.events";
    public static PropertyPaddocks = "supplychain.properties.paddocks";
    public static PropertySpecies = "supplychain.properties.species";
   public static PropertyBusinessActivities = "supplychain.properties.businessactivities";
   public static PropertyActivityEvents = "supplychain.properties.activityevents";
    
    public static ImagingMethods = "imaging.methods.view";
    public static ImagingDevices = "imaging.devices.view";
    
    
    public static DashboardNotices = "dashboard.notices";
    public static DashboardStatus = "dashboard.devices";
    public static ConnectViaCloudLink = "dashboard.devices.cloudlink";

    public static Supporter = "rataplatform.supporter";

    public static MarkUpAllocate = "markup.allocate";
    public static MarkUpEdit = "markup.edit";
    public static MarkUpView = "markup.view";
    public static MarkupAudit = "markup.audit";
    public static MarkUpManageReferrals = "markup.managereferrals";
    
    public static MarkupResultsSend = "markup.results.send";
    public static MarkupResultsAudit = "markup.results.audit";

}